import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=67080e6a&scoped=true&"
import script from "./resetPwd.js?vue&type=script&lang=js&"
export * from "./resetPwd.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67080e6a",
  null
  
)

export default component.exports